'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

var _combineStyles = require('../internal/combine-styles');

var _combineStyles2 = _interopRequireDefault(_combineStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var root = function root(overrideStyles) {
  return (0, _combineStyles2.default)(_styles2.default.root, overrideStyles);
};

var cover = function cover(overrideStyles) {
  return (0, _combineStyles2.default)(_styles2.default.cover, overrideStyles);
};

var coverImage = function coverImage(image, overrideStyles) {
  var style = (0, _combineStyles2.default)(_styles2.default.coverImage, image);

  return (0, _combineStyles2.default)(style, overrideStyles);
};

var avatar = function avatar(overrideStyles) {
  return (0, _combineStyles2.default)(_styles2.default.avatar, overrideStyles);
};

var header = function header(overrideStyles) {
  return (0, _combineStyles2.default)(_styles2.default.header, overrideStyles);
};

var secondaryText = function secondaryText(overrideStyles) {
  return (0, _combineStyles2.default)(_styles2.default.secondaryText, overrideStyles);
};

exports.default = {
  root: root,
  cover: cover,
  coverImage: coverImage,
  avatar: avatar,
  header: header,
  secondaryText: secondaryText
};
module.exports = exports.default;